/* eslint-disable max-len */
import React from 'react';

export const PhoneSpot = (): React.ReactElement => (
  <svg fill="none" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="27.589" cy="28.0563" fill="#F7F5F0" rx="27.589" ry="27.6784" />
    <path
      clipRule="evenodd"
      d="M18.0977 11.7944c0-1.6568 1.3431-2.99997 3-2.99997h14.091c1.6568 0 3 1.34317 3 2.99997v33.2012c0 1.6569-1.3432 3-3 3h-14.091c-1.6569 0-3-1.3431-3-3V11.7944Z"
      fill="#25694F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M38.1887 44.0746V12.7175c0-2.1654-1.7534-3.92108-3.9164-3.92148l-12.2574-.00159c-2.1635 0-3.9172 1.75567-3.9172 3.92147V44.073c0 2.1654 1.7533 3.9207 3.916 3.9211l12.2574.0015c2.1634.0004 3.9176-1.7552 3.9176-3.921Z"
      fill="#25694F"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="m21.5669 44.663 12.9434-.0115c1.1358-.0012 2.0547-.9246 2.0535-2.0634l-.0305-29.8306c-.0012-1.1381-.9221-2.0595-2.0575-2.0583l-12.9438.0115c-1.135.0012-2.0547.9246-2.0535 2.0631l.0313 29.8305c.0008 1.1385.9221 2.0599 2.0571 2.0587"
      fill="#fff"
      fillRule="evenodd"
    />
    <path
      d="M21.5969 28.7515c-.5874-2.9517.9803-5.9081 3.7511-7.0743 2.7707-1.1662 5.9802-.2203 7.6797 2.2633.1408.2061.1143.4834-.0629.6589l-4.9054 4.8531c-.0971.0963-.2286.15-.3654.1491-.1368-.0008-.2677-.0561-.3638-.1536l-2.3088-2.3385c-.1295-.131-.1793-.3212-.1306-.4989.0486-.1777.1882-.3158.3663-.3624.1781-.0466.3675.0054.497.1365l1.947 1.971 4.2204-4.1755c-1.6237-2.0041-4.4517-2.5494-6.7009-1.2921-2.2492 1.2573-3.2674 3.9525-2.4125 6.3864.8549 2.4338 3.3349 3.9003 5.8763 3.475 2.5415-.4254 4.4073-2.6193 4.4211-5.1986.0008-.1493-.004-.2987-.016-.445-.0221-.2842.1901-.5324.474-.5544.2839-.0219.532.1906.5542.4748.0128.175.0195.3536.0185.531-.0225 3.4978-2.8703 6.315-6.3651 6.2967-3.0065-.0185-5.5868-2.1509-6.1742-5.1025Z"
      fill="#38AF88"
    />
    <path
      clipRule="evenodd"
      d="m26.8651 46.8845 2.7283.0004c.3372.0004.6135-.286.6135-.6365v-.155c0-.35-.2763-.6364-.6131-.6364l-2.7283-.0005c-.3376 0-.6135.2861-.6135.6365v.155c0 .3501.2759.6365.6131.6365Z"
      fill="#fff"
      fillRule="evenodd"
    />
  </svg>
);
